import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiService } from '../../service/api.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
declare const google: any;

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  sendOtp: boolean = false;
  otp: string[] = ['', '', '', ''];
  otps: string[] = [];
  mobile: any = '';
  avail: any;
  msg: any = '';
  constructor(
    private dialog: MatDialogRef<LoginComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private api: ApiService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (value && index < this.otp.length - 1) {
      const nextInput = input.nextElementSibling as HTMLInputElement;
      nextInput?.focus();
    }
    if (value.length > 1) {
      input.value = value[0];
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = input.previousElementSibling as HTMLInputElement;
      prevInput?.focus();
    }
  }

  getOtp() {
    return this.otps.join('');
  }

  userValidate() {
    const body = {
      phone: this.mobile,
    };
    this.api.commonPostfun('user/d/validate', body).subscribe((res: any) => {
      if (res.status && res.statusCode == 200) {
        this.sendOtp = true;
        this.timer(10);
      } else {
        this.sendOtp = false;
      }
    });
  }

  saveUser() {
    const body = {
      phone: this.mobile,
      otp: this.getOtp(),
    };
    this.api
      .commonPostfun('user/d/otp/validate', body)
      .subscribe((res: any) => {
        if (res.status && res.statusCode == 200) {
          this.sendOtp = true;
          localStorage.setItem('userData', JSON.stringify(res.response));
          this.api
            .commonGetfun('seller/fetch/validateRoutes')
            .subscribe((res: any) => {
              if (res.status) {
                let userInfo = res.response[0];
                sessionStorage.setItem('sellerInfo', JSON.stringify(userInfo));
              }
            });
          this.close(res.status);
        } else {
          this.sendOtp = false;
        }
      });
  }
  close(status: any) {
    this.dialog.close(status);
  }
  resendOTP() {
    this.timerOn = true;
    const body = {
      mobile: this.mobile,
    };
    this.api.commonPostfun('user/resend', body).subscribe((res: any) => {
      if (res.status && res.statusCode == 200) {
        this.sendOtp = true;
        this.timer(10);
      } else {
        this.sendOtp = false;
      }
    });
  }

  timerOn = true;
  resendOtpTime: any;
  timer(remaining: number) {
    var m: any = Math.floor(remaining / 60);
    var s: any = remaining % 60;
    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;
    this.resendOtpTime = m + ':' + s;
    remaining -= 1;
    if (remaining >= 0 && this.timerOn) {
      setTimeout(() => {
        this.timer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      return;
    }
  }
}
